import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { Col, Container, Row as slRow } from '@slal/ui/layout';

export const StyledContainer = styled(Container)`
    margin-top: ${({ theme }) => theme.space[6]};
    margin-bottom: ${({ theme }) => theme.space[6]};
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${breakpointUp.md`
        gap: 24px;
        margin-top: ${({ theme }) => theme.space[7]};
        margin-bottom: ${({ theme }) => theme.space[7]};
    `}
`;

export const Row = styled(slRow)`
    > div:nth-of-type(2) {
        align-self: flex-start;
    }
`;

export const CenterCol = styled(Col)`
    margin: auto;
`;

export const DesktopCol = styled(Col)`
    display: none;

    ${breakpointUp.md`
      display:block;
    `}
`;

export const BannerLayout = styled.div`
    background-color: #ffffff;
`;

export const BannerContainer = styled(Container)`
    padding: 0;
    padding-top: ${({ theme }) => theme.space[6]};
    padding-bottom: ${({ theme }) => theme.space[6]};
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${breakpointUp.md`
        gap: 24px;
        padding-top: ${({ theme }) => theme.space[7]};
        padding-bottom: ${({ theme }) => theme.space[7]};
    `}
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 960px;
    gap: 16px;
`;
